import { Validate } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../translations';
import { PasswordUpdateFormBean, PasswordUpdateFormController } from '../PasswordUpdateForm.types';

import { NewPasswordField } from './NewPasswordField';

type RepeatNewPasswordProps = Pick<PasswordUpdateFormController, 'register'>;

const validate: Validate<PasswordUpdateFormBean> = (data, getValue) => {
   const newPassword = getValue(NewPasswordField.fieldName);
   if (newPassword !== data) {
      return personnelTranslationKeys.myAccount.password.passwordsAreDifferent;
   }

   return undefined;
};

export const RepeatNewPasswordField = (props: RepeatNewPasswordProps): JSX.Element => {
   const controller = props.register(RepeatNewPasswordField.fieldName, { required: true, validate: validate });

   return (
      <PasswordInput
         testId={'newPassword'}
         autoComplete={'new-password'}
         label={personnelTranslationKeys.myAccount.password.repeatNewPassword}
         controller={controller}
      />
   );
};

RepeatNewPasswordField.fieldName = 'repeatNewPassword' as const;
